import {useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import StoresHeader from '../../components/StoresHeader';
import StoresClients from '../../components/StoresClients';
import StoresSites from '../../components/StoresSites';
import StoresEdges from '../../components/StoresEdges';
import StoresSensors from '../../components/StoresSensors';
import StoresCameras from '../../components/camera/StoresCameras';
import StoresFields from '../../components/StoresFields';
import {colors} from "../../maps/colors";
import {api} from "../../maps/data.js";
import {addOrDeleteQueryParams, getQueryValue} from "../../domain/queryHandler";

export default function StoresPage() {
    const history = useNavigate();
    const location = useLocation();

    const clientId = getQueryValue(location, 'client');
    const siteId = getQueryValue(location, 'site');
    const edgeId = getQueryValue(location, 'edge');


    const [clients, s_clients] = useState([]);
    const [sites, s_sites] = useState([]);
    const [edges, s_edges] = useState([]);

    const [selected_client, s_selected_client] = useState({});
    const [selected_site, s_selected_site] = useState({});
    const [selected_edge, s_selected_edge] = useState({});
    const [forceFieldUpdate, s_forceFieldUpdate] = useState(0);

    const getClients = async () => {
        const res = await api({type: 'getClients'});
        s_clients(res);
    };
    const getSites = async () => {
        if (clientId) {
            const res = await api({
                type: 'getSites',
                data: {
                    clientId: clientId
                }
            });
            s_sites(res);
        }
    };
    const getEdges = async () => {
        if (siteId) {
            const res = await api({
                type: 'getEdges',
                data: {
                    siteId: siteId
                }
            });
            s_edges(res);
        }
    };

    useEffect(() => {
        getClients();
    }, []);

    useEffect(() => {
        getSites();
    }, [clientId]);

    useEffect(() => {
        getEdges();
    }, [siteId]);

    useEffect(() => {
        if (clients?.length) {
            const client = clients.find(cl => cl._id === clientId);
            if (client) {
                s_selected_client(client);
                s_selected_site({});
                s_selected_edge({});
            }
        }
    }, [clientId, clients]);

    useEffect(() => {
        const isSelectedClientExist = Object.keys(selected_client)?.length;
        if (sites?.length && isSelectedClientExist) {
            const site = sites.find(cl => cl._id === siteId);
            if (site) {
                s_selected_site(site);
                s_selected_edge({});
            }
        }
    }, [siteId, sites, selected_client]);

    useEffect(() => {
        const isSelectedClientExist = Object.keys(selected_client)?.length;
        const isSelectedSiteExist = Object.keys(selected_site)?.length;
        if (edges?.length && isSelectedSiteExist && isSelectedClientExist) {
            const edge = edges.find(cl => cl._id === edgeId);
            if (edge) {
                s_selected_edge(edge);
            }
        }
    }, [edgeId, edges, selected_client, selected_site]);

    const changeUrl = (query) => {
        history({
            search: query
        });
    };

    return (
        <>
            <StoresHeader/>
            <div style={{height: 'calc(100vh - 104px)', overflow: 'hidden', background: colors.GRAY3}}>
                <StoresClients
                    clients={clients}
                    getClients={getClients}
                    selectedClient={selected_client}
                    onSelected={client => {
                        const urlToPush = addOrDeleteQueryParams(location, [{client: client._id}, {site: null}, {edge: null}]);
                        changeUrl(urlToPush);
                    }}/>
                {
                    selected_client._id &&
                    <StoresSites
                        selectedClient={selected_client}
                        selectedSite={selected_site}
                        edges={edges}
                        sites={sites}
                        getSites={getSites}
                        onSelected={site => {
                            const urlToPush = addOrDeleteQueryParams(location, [{site: site._id}, {edge: null}]);
                            changeUrl(urlToPush);
                        }}
                    />
                }
                {
                    selected_site._id && <StoresEdges
                        selectedClient={selected_client}
                        selectedSite={selected_site}
                        selectedEdge={selected_edge}
                        edges={edges}
                        getEdges={getEdges}
                        onSelected={edge => {
                            const urlToPush = addOrDeleteQueryParams(location, [{edge: edge._id}]);
                            changeUrl(urlToPush);
                        }}/>
                }
                {
                    selected_edge._id && <>
                        <StoresSensors
                            selectedClient={selected_client}
                            selectedSite={selected_site}
                            selectedEdge={selected_edge}
                        />

                        <StoresCameras
                            selectedClient={selected_client}
                            selectedSite={selected_site}
                            selectedEdge={selected_edge}
                            getSites={getSites}
                            forceFieldUpdate={() => {
                                s_forceFieldUpdate(forceFieldUpdate + 1);
                            }}
                        />

                        <StoresFields
                            selectedClient={selected_client}
                            selectedSite={selected_site}
                            selectedEdge={selected_edge}
                            forceFieldUpdate={forceFieldUpdate}
                        />

                    </>
                }

            </div>

        </>

    );
}